<template>
  <span :class="classes">
    <slot></slot>
  </span>
</template>
<script setup lang="ts">
import { computed } from "vue";

import type { Variant, Size } from "./types";

export interface PillProps {
  variant?: Variant;
  size?: Size;
  uppercase?: boolean;
}

const variants = {
  info: "tw-border-info-500 tw-text-info-500",
  warning: "tw-border-warning-500 tw-text-warning-500",
  danger: "tw-border-danger-500 tw-text-danger-500",
  success: "tw-border-success-500 tw-text-success-500",
  infoFull: "tw-border-info-600 tw-bg-info-600 tw-text-white",
  successFull: "tw-border-success-500 tw-bg-success-500 tw-text-white",
  darkFull: "tw-border-dorian-gray-600 tw-bg-dorian-gray-600 tw-text-white",
  none: "",
};

const sizes = {
  xs: "tw-text-xs tw-px-2",
  sm: "tw-text-sm tw-px-2 tw-py-1",
};

const props = withDefaults(defineProps<PillProps>(), {
  variant: "info",
  size: "xs",
  uppercase: true,
});

const classes = computed(() => {
  return [
    "tw-rounded-2xl tw-border tw-border-solid tw-font-semibold tw-inline-block",
    variants[props.variant],
    sizes[props.size],
    props.uppercase && "tw-uppercase",
  ];
});
</script>
